// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import echarts from 'echarts'
import store from '@S' // store状态管理库
import ViewUI from 'view-design'
import axios from '@H'
import moment from 'moment'
import './assets/font/iconfont.css'
import URLS, {
  Actions
} from '@/assets/js/urls.js'
import '@/assets/js/common.js'
import 'view-design/dist/styles/iview.css'
import DsAtt from '@/components/dsatt'
import DsSelect from '@/components/dsselect'
import DsAudit from '@/components/dsaudit'
import DsList from '@/components/dsattlist'
import FilterCard from '@/components/filtercard'
// import DsEditor from '@/components/dseditor'
import DsTree from '@/components/dstree'
import Print from 'vue-print-nb'
import 'babel-polyfill'
Vue.use(DsAtt)
Vue.use(DsSelect)
Vue.use(DsList)
Vue.use(DsAudit)
Vue.use(FilterCard)
// Vue.use(DsEditor)
Vue.use(DsTree)
Vue.use(Print)
// 注册echarts组件
Vue.prototype.$echarts = echarts
// 请求
Vue.prototype.$URLS = URLS
Vue.prototype.$Actions = Actions
Vue.prototype.$moment = moment
Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.use(ViewUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js